export const CREATE_TEMPLATE_MUTATION = `
  mutation Mutation($reportName: String!, $companyId: String!, $tables: [TableInput], $email: JSON, $exportConfig: JSON) {
  createTemplate(reportName: $reportName, companyId: $companyId, tables: $tables, email: $email, exportConfig: $exportConfig) {
    success
    status
    message
    data
  }
}
`;
